import React from 'react';
import {
    Box,
    Checkbox,
    Chip,
    Divider,
    Grid,
    Typography,
} from '@material-ui/core';
import { StyledAutocomplete } from './FormUI';
import { HUB_TYPE_ENUM } from '../../../../utils/constants';
import { CustomTextField } from '../../../../components/Textfield';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;

export default function ClientIdSection({
    isEdit,
    workTabHubNShiftList,
    hubs,
    allowHubZoneEdit,
    zonesWithHub,
    setZonesWithHub,
    zoneOptions,
    formik,
    overlapShifts,
    bothShiftsIsThere,
}) {
    const getHubOperations = () => {
        let hubOp = [];
        workTabHubNShiftList.forEach((op) => {
            const operationType = op.primaryOperation?.toUpperCase();
            if (operationType !== HUB_TYPE_ENUM.STORE.value)
                hubOp.push(HUB_TYPE_ENUM[operationType]?.value);
        });
        return hubOp?.filter((h) => !!h);
    };

    const getHubForOperation = (operation) => {
        let selectedHub = {};
        workTabHubNShiftList.forEach((hub) => {
            const hubInfo = hubs?.find((si) => hub?.hubId === si?.id);
            if (hubInfo) {
                const operationType = hubInfo.primaryOperation?.toUpperCase();
                if (HUB_TYPE_ENUM[operationType]?.value === operation) {
                    selectedHub = hub;
                }
            }
        });
        return selectedHub;
    };

    const primaryOperations = getHubOperations();
    let isChecked = workTabHubNShiftList?.some((hub) => hub?.hubId);
    if (!!isEdit) {
        isChecked = !!(
            // ?.filter((h) => h === HUB_TYPE_ENUM.FOOD.value)
            workTabHubNShiftList?.map((h) => h.primaryOperation)?.length
        );
    }
    return (
        !!isChecked &&
        !!primaryOperations?.length && (
            <Grid container spacing={2} style={{ marginTop: 22 }}>
                <Grid item xs={12}>
                    <Typography
                        style={{
                            fontSize: '18px',
                            fontWeight: 600,
                            marginBottom: '18px',
                        }}
                        variant="body1"
                    >
                        Client ID Creation
                    </Typography>
                    <Divider />
                </Grid>
                {primaryOperations?.map((item, index) => {
                    let hub = {};
                    workTabHubNShiftList.forEach((Hub) => {
                        if (Hub?.primaryOperation === item) {
                            hub = Hub;
                        }
                    });
                    let selectedPrimaryOperation =
                        HUB_TYPE_ENUM[item?.toUpperCase()]?.value;
                    const selectedOperation =
                        formik?.values?.omsUserDetails?.find(
                            (i) =>
                                selectedPrimaryOperation ===
                                i?.primaryOperation,
                        );
                    if (
                        !selectedOperation?.omsUserId &&
                        !!isEdit &&
                        selectedPrimaryOperation === HUB_TYPE_ENUM.ECOM.value
                    ) {
                        selectedPrimaryOperation = null;
                    }
                    return (
                        !!selectedPrimaryOperation && (
                            <Grid item xs={6}>
                                <Box
                                    style={{
                                        marginBottom: 8,
                                    }}
                                >
                                    <Box
                                        style={{
                                            backgroundColor:
                                                HUB_TYPE_ENUM[
                                                    selectedPrimaryOperation
                                                ]?.bgColor,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            padding: '6px 12px',
                                            borderTopLeftRadius: 8,
                                            borderTopRightRadius: 8,
                                            border: 'solid 1px #f0e7e6',
                                            borderBottom: 'none',
                                        }}
                                    >
                                        <Typography
                                            variant="inherit"
                                            style={{
                                                color: '#252525',
                                                fontSize: 14,
                                            }}
                                        >
                                            {HUB_TYPE_ENUM[
                                                selectedPrimaryOperation
                                            ]?.product + ' ID Details: '}
                                            <Typography
                                                variant="inherit"
                                                style={{
                                                    color: '#252525',
                                                    fontWeight: 600,
                                                    fontSize: 14,
                                                }}
                                            >
                                                {!!isEdit
                                                    ? selectedOperation?.omsUserId
                                                    : 'ID will be created after staff added'}
                                            </Typography>
                                        </Typography>
                                    </Box>
                                    <Box
                                        style={{
                                            borderBottomLeftRadius: 8,
                                            borderBottomRightRadius: 8,
                                            border: 'solid 1px rgba(38, 50, 56, 0.16)',
                                            borderTop: 'none',
                                            width: '100%',
                                        }}
                                    >
                                        {
                                            <Box
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="space-between"
                                            >
                                                <StyledAutocomplete
                                                    multiple={
                                                        HUB_TYPE_ENUM.ECOM
                                                            .value !==
                                                        selectedPrimaryOperation
                                                    }
                                                    disabled={
                                                        !allowHubZoneEdit ||
                                                        HUB_TYPE_ENUM.ECOM
                                                            .value ===
                                                            selectedPrimaryOperation
                                                    }
                                                    disableCloseOnSelect={true}
                                                    limitTags={2}
                                                    key={index}
                                                    options={
                                                        zoneOptions?.[
                                                            hub?.hubId
                                                        ] ?? []
                                                    }
                                                    getOptionLabel={(option) =>
                                                        `${option.zoneName}`
                                                    }
                                                    disableClearable
                                                    filterSelectedOptions={
                                                        false
                                                    }
                                                    value={
                                                        HUB_TYPE_ENUM.ECOM
                                                            .value ===
                                                        selectedPrimaryOperation
                                                            ? null
                                                            : zonesWithHub[
                                                                  selectedPrimaryOperation
                                                              ]
                                                    }
                                                    onChange={(e, newValue) => {
                                                        setZonesWithHub(
                                                            (prev) => {
                                                                return {
                                                                    ...prev,
                                                                    [selectedPrimaryOperation]:
                                                                        HUB_TYPE_ENUM
                                                                            .ECOM
                                                                            .value ===
                                                                        selectedPrimaryOperation
                                                                            ? [
                                                                                  newValue,
                                                                              ]
                                                                            : newValue,
                                                                };
                                                            },
                                                        );
                                                    }}
                                                    includeInputInList={true}
                                                    getLimitTagsText={(
                                                        more,
                                                    ) => {
                                                        let border = 'none';
                                                        return (
                                                            <Chip
                                                                style={{
                                                                    border,
                                                                }}
                                                                label={`+${more}`}
                                                            />
                                                        );
                                                    }}
                                                    renderTags={(
                                                        values,
                                                        props,
                                                    ) => {
                                                        return values.map(
                                                            (zone) => {
                                                                return (
                                                                    <Chip
                                                                        disabled={
                                                                            isEdit
                                                                        }
                                                                        onDelete={() => {
                                                                            setZonesWithHub(
                                                                                {
                                                                                    [selectedPrimaryOperation]:
                                                                                        zonesWithHub?.length
                                                                                            ? zonesWithHub?.filter(
                                                                                                  (
                                                                                                      i,
                                                                                                  ) =>
                                                                                                      i?.id !==
                                                                                                      zone?.id,
                                                                                              )
                                                                                            : [],
                                                                                },
                                                                            );
                                                                        }}
                                                                        style={{
                                                                            marginRight: 4,
                                                                            border:
                                                                                bothShiftsIsThere ||
                                                                                overlapShifts.includes(
                                                                                    zone.id,
                                                                                )
                                                                                    ? '1px solid red'
                                                                                    : 'none',
                                                                        }}
                                                                        label={`${zone.zoneName}`}
                                                                    />
                                                                );
                                                            },
                                                        );
                                                    }}
                                                    renderOption={(
                                                        option,
                                                        { selected },
                                                    ) => (
                                                        <Box
                                                            style={{
                                                                display: 'flex',
                                                                alignItems:
                                                                    'center',
                                                                justifyContent:
                                                                    'space-between',
                                                                width: '100%',
                                                                borderBottom:
                                                                    '1px solid #EBEBEB',
                                                            }}
                                                        >
                                                            <Box>
                                                                <Typography
                                                                    style={{
                                                                        fontSize:
                                                                            '12px',
                                                                        fontWeight: 600,
                                                                    }}
                                                                >
                                                                    {
                                                                        option.zoneName
                                                                    }
                                                                </Typography>
                                                                <Typography
                                                                    style={{
                                                                        fontSize:
                                                                            '10px',
                                                                        fontWeight: 600,
                                                                    }}
                                                                >
                                                                    {
                                                                        option.zoneName
                                                                    }
                                                                </Typography>
                                                            </Box>
                                                            <Checkbox
                                                                icon={icon}
                                                                style={{
                                                                    marginRight: 8,
                                                                }}
                                                                color={
                                                                    'primary'
                                                                }
                                                                checked={
                                                                    selected
                                                                }
                                                            />
                                                        </Box>
                                                    )}
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    renderInput={(params) => (
                                                        <CustomTextField
                                                            {...params}
                                                            id={hub?.name}
                                                            name={hub?.name}
                                                            placeholder={
                                                                HUB_TYPE_ENUM
                                                                    .ECOM
                                                                    .value ===
                                                                selectedPrimaryOperation
                                                                    ? 'Zones are auto selected, no need to assign zone.'
                                                                    : hub?.zones
                                                                          ?.length
                                                                    ? ''
                                                                    : !!isEdit
                                                                    ? 'Please use Atlas to Edit Zones'
                                                                    : 'Select Zones*'
                                                            }
                                                            fullWidth={true}
                                                            error={
                                                                formik.touched
                                                                    .zones &&
                                                                selectedPrimaryOperation ===
                                                                    HUB_TYPE_ENUM
                                                                        .FOOD
                                                                        .value
                                                            }
                                                            helperText={
                                                                formik.touched
                                                                    .zones &&
                                                                selectedPrimaryOperation ===
                                                                    HUB_TYPE_ENUM
                                                                        .FOOD
                                                                        .value &&
                                                                'Please select zones'
                                                            }
                                                        />
                                                    )}
                                                />
                                            </Box>
                                        }
                                    </Box>
                                </Box>
                            </Grid>
                        )
                    );
                })}
            </Grid>
        )
    );
}
